import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ComparisonControlViewModel from '@/Components/ComparisonControl/ComparisonControlViewModel';
import ImageT from '@/Controls/Image';

export default class ComparisonControl extends Control {
    private Image = ComponentManager.getControl<typeof ImageT>('Image');

    constructor(private $originalControl: JQuery, private viewModel: ComparisonControlViewModel) {
        super(viewModel);
    }

    public getControl(): JQuery {
        const $wrapper = $('<div>');

        this.applyBindings($wrapper, {
            controlName: 'comparisoncontrol',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
        });

        this.$originalControl.addClass('original');
        $wrapper.append(this.$originalControl);

        const comparisonIcon = this.createComparisonIcon();
        const $comparisonIcon = comparisonIcon.getTuple().control;
        $comparisonIcon.addClass('icon');
        $wrapper.append($comparisonIcon);

        return $wrapper;
    }

    private createComparisonIcon(): ImageT {
        return new this.Image(this.viewModel.comparisonIconViewModel);
    }
}

ComponentManager.setControl('ComparisonControl', ComparisonControl, 'RADPresentation.HTMLClient.DefaultViewExtensions');